function openEmbroideryModal() {
    const modal = document.querySelector('.embroidery-modal');
    const body = document.body;
    if (modal) {
        modal.classList.add('open');
        body.style.overflow = 'hidden';
    }

    // scroll to top of the scrollable area
    const scrollableArea = modal.querySelector('.embroidery-form__scroll');
    const scrollableAreaMobile = modal.querySelector('.embroidery-form');

    scrollableArea.scrollTop = 0;
    scrollableAreaMobile.scrollTop = 0;

    initEmbroidery();
}

function closeEmbroideryModal() {
    const modal = document.querySelector('.embroidery-modal');
    const body = document.body;
    if (modal) {
        modal.classList.remove('open');
        body.style.overflow = '';
    }
}

function checkUrlForEmbroideryOpen() {
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has('embroidery')) {
        openEmbroideryModal();
    }
}

document.addEventListener('DOMContentLoaded', () => {
    checkUrlForEmbroideryOpen();
});

function initEmbroidery() {
    const embroideryText = document.querySelector('.js-embroidery-text');
    const embroideryColorOptions = document.querySelectorAll('.js-embroidery-color-option');
    const embroideryFontOptions = document.querySelectorAll('.js-embroidery-font-option');
    const embroideryPlacementOptions = document.querySelectorAll('.js-embroidery-placement-option');
    const embroideryConsentCheckboxes = document.querySelectorAll('.js-embroidery-consent');
    const embroideryPreview = document.querySelector('.js-embroidery-text-preview');


    embroideryText.addEventListener('change', () => {
        const text = embroideryText.value;
        embroideryPreview.innerHTML = text;
        enableSubmitButton();
    });

    embroideryColorOptions.forEach(option => {
        if(option.classList.contains('selected')) {
            embroideryPreview.style.color = option.querySelector('input').dataset.color;
        }
        option.addEventListener('click', () => {
            embroideryColorOptions.forEach(opt => opt.classList.remove('selected'));
            option.classList.add('selected');
            embroideryPreview.style.color = option.querySelector('input').dataset.color;
        });
    });

    embroideryFontOptions.forEach(option => {
        if(option.classList.contains('selected')) {
            const font = option.querySelector('input').dataset.font;
            embroideryPreview.style.fontFamily = font;
        }
        option.addEventListener('click', () => {
            embroideryFontOptions.forEach(opt => opt.classList.remove('selected'));
            option.classList.add('selected');
            const font = option.querySelector('input').dataset.font;
            embroideryPreview.style.fontFamily = font;
        });
    });

    embroideryPlacementOptions.forEach(option => {
        option.addEventListener('click', () => {
            embroideryPlacementOptions.forEach(opt => opt.classList.remove('selected'));
            option.classList.add('selected');
        });
    });

    embroideryConsentCheckboxes.forEach(checkbox => {
        checkbox.addEventListener('click', () => {
            let input = checkbox.querySelector('input');
            if (input.checked) {
                checkbox.classList.remove('checked');
                input.checked = false;

            } else {
                checkbox.classList.add('checked');
                input.checked = true;
            }
            enableSubmitButton();
        });
    });
}

function enableSubmitButton() {
    const embroiderySubmitButton = document.querySelector('.js-embroidery-submit');
    const embroideryConsentCheckboxes = document.querySelectorAll('.js-embroidery-consent');
    const allChecked = Array.from(embroideryConsentCheckboxes).every(checkbox => checkbox.querySelector('input').checked);

    const embroideryText = document.querySelector('.js-embroidery-text');
    const embroideryTextError = document.querySelector('.js-embroidery-text-error');
    const textValid = embroideryText.value.trim().length > 0 && embroideryText.value.trim().length <= 20;

    if (allChecked && textValid) {
        embroiderySubmitButton.removeAttribute('disabled');
        embroideryTextError.style.display = 'none';
    } else {
        embroiderySubmitButton.setAttribute('disabled', 'disabled');
        if (!textValid) {
            embroideryTextError.style.display = 'block';
        } else {
            embroideryTextError.style.display = 'none';
        }
    }
}

function addEmbroidery() {
    const embroideryText = document.querySelector('.js-embroidery-text').value;
    const selectedColor = document.querySelector('.js-embroidery-color-option.selected input').value;
    const selectedFont = document.querySelector('.js-embroidery-font-option.selected input').value;
    const selectedPlacement = document.querySelector('.js-embroidery-placement-option.selected input').value;

    const properties = document.querySelector('.js-embroidery-properties');
    const propertyText = properties.querySelector('.js-property-embroidery-text');
    const propertyColor = properties.querySelector('.js-property-embroidery-thread-color');
    const propertyFont = properties.querySelector('.js-property-embroidery-font');
    const propertyPlacement = properties.querySelector('.js-property-embroidery-placement');

    propertyText.value = embroideryText;
    propertyColor.value = selectedColor;
    propertyFont.value = selectedFont;
    propertyPlacement.value = selectedPlacement;
    properties.classList.remove('hidden');

    const productForm = document.querySelector('.js-product-form');
    productForm.classList.add('embroidery-added');


    const addEmbroideryText = document.querySelector('.js-add-embroidery-text');
    const editEmbroideryText = document.querySelector('.js-edit-embroidery-text');
    const removeEmbroideryButton = document.querySelector('.js-embroidery-remove');
    const quantity = document.querySelector('.js-quantity-selector');
    if(quantity) {
        quantity.classList.add('hidden');
    }
    removeEmbroideryButton.classList.remove('hidden');
    addEmbroideryText.classList.add('hidden');
    editEmbroideryText.classList.remove('hidden');


    closeEmbroideryModal();
}

function removeEmbroidery() {
    const properties = document.querySelector('.js-embroidery-properties');
    const propertyText = properties.querySelector('.js-property-embroidery-text');
    const propertyColor = properties.querySelector('.js-property-embroidery-thread-color');
    const propertyFont = properties.querySelector('.js-property-embroidery-font');
    const propertyPlacement = properties.querySelector('.js-property-embroidery-placement');

    propertyText.value = '';
    propertyColor.value = '';
    propertyFont.value = '';
    propertyPlacement.value = '';
    properties.classList.add('hidden');

    const productForm = document.querySelector('.js-product-form');
    productForm.classList.remove('embroidery-added');

    const addEmbroideryText = document.querySelector('.js-add-embroidery-text');
    const editEmbroideryText = document.querySelector('.js-edit-embroidery-text');
    const removeEmbroideryButton = document.querySelector('.js-embroidery-remove');
    const quantity = document.querySelector('.js-quantity-selector');
    if(quantity){
        quantity.classList.remove('hidden');
    }
    removeEmbroideryButton.classList.add('hidden');
    addEmbroideryText.classList.remove('hidden');
    editEmbroideryText.classList.add('hidden');
}

function addEmbroideryToCart() {
    let properties = document.querySelector('.js-embroidery-properties');
    let propertyText = properties.querySelector('.js-property-embroidery-text').value;
    let propertyColor = properties.querySelector('.js-property-embroidery-thread-color').value;
    let propertyFont = properties.querySelector('.js-property-embroidery-font').value;
    let propertyPlacement = properties.querySelector('.js-property-embroidery-placement').value;
    let embroideryProduct = properties.querySelector('.js-embroidery-product-id').value;

    let productForm = document.querySelector('.js-product-form');
    let productId = productForm.querySelector('input[name="id"]').value;
    let quantity = document.querySelector('input[name="quantity"]').value;
    let product = document.querySelector('.js-product-title');
    let productTitle = product.textContent;
    let variantPicker = document.querySelector('.variant-picker');
    let selectedVariantInputs = variantPicker.querySelectorAll('input:checked');

    selectedVariantInputs.forEach(variant => {
        let label = document.querySelector(`label[for="${variant.id}"] span`);
        if (label) {
            productTitle += ` - ${label.innerHTML}`;
        }
    });

    // create unique identifier for the embroidery product
    let randomNumber = Math.floor(Math.random() * 1000000);
    let uniqueIdentifier = `${productId}-${propertyText}-${propertyColor}-${propertyFont}-${propertyPlacement}-${randomNumber}`;


    let formData = {
        'items': [{
            'id': parseInt(productId),
            'quantity': parseInt(quantity),
            'properties': {
                'Embroidery Text': propertyText,
                'Thread Color': propertyColor,
                'Font': propertyFont,
                'Placement': propertyPlacement,
                '_product_match': uniqueIdentifier
            }
        },
        {
            'id': parseInt(embroideryProduct),
            'quantity': parseInt(quantity),
            'properties': {
                'For': productTitle,
                '_variant_id': productId,
                '_product_match': uniqueIdentifier,
            }
        }]
    };


    fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    })
    .then(response => {
        return response.json();
    })
    .then(data => {
        cartRefresh();
    })
    .catch((error) => {
        console.error('Error:', error);
    });
    removeEmbroidery();
}

function initVariantChangeListener() {
    const productForm = document.querySelector('.js-product-form');
    const variant = productForm.querySelector('input[name="id"]');
    const addToCartButton = productForm.querySelector('.buy-buttons button[type="submit"]');
    const embroideryAtcButton = productForm.querySelector('.js-embroidery-atc-btn');
    const embroideryWrapper = document.querySelector('.embroidery-btn-wrapper');

    if (variantsToHideEmbroidery.includes(parseInt(variant.value))) {
        productForm.classList.add('embroidery-hidden');
        embroideryWrapper.style.display = 'none';
    }

    variant.addEventListener('change', () => {
       // check if addToCartButton is disabled
        if (addToCartButton.disabled) {
            embroideryAtcButton.disabled = true;
            embroideryAtcButton.innerText = "Sold Out";
        } else {
            embroideryAtcButton.disabled = false;
            embroideryAtcButton.innerText = "Add to Cart";
        }

        if (variantsToHideEmbroidery.includes(parseInt(variant.value))) {
            productForm.classList.add('embroidery-hidden');
            embroideryWrapper.style.display = 'none';
        } else {
            embroideryWrapper.style.display = 'flex';
            productForm.classList.remove('embroidery-hidden');}
    });
}